import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { MessagesDisplayContainer, TextboxTemplate } from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  landingMessagesAtom,
  VERIFICATION_CODE_PLACE_HOLDER,
  VerifyCodeStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepVerifyCode } from "./use-step-verify-code";

export const StepVerifyCode: FC = () => {
  const { methods, handleCodeVerification, resendOtp, isContinueCanBeApply } =
    useStepVerifyCode();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <div className="landing-top-illustration" aria-hidden="true"></div>
        <h1 className="landing-title">{t("landing.verifyCode.title")}</h1>

        <div className="landing-form-field">
          <label htmlFor={VerifyCodeStepFormFieldsEnum.VerificationCode}>
            {t("landing.formLabel.verificationCode")}*
          </label>
          <TextboxTemplate
            name={VerifyCodeStepFormFieldsEnum.VerificationCode}
            placeholder={VERIFICATION_CODE_PLACE_HOLDER}
            uniqueAttrId={VerifyCodeStepFormFieldsEnum.VerificationCode}
          />
        </div>

        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />

        <ContinueButton
          disabled={!isContinueCanBeApply}
          onClick={handleCodeVerification}
          loading={isApiLoading}
        />

        <div className="landing-container-footer">
          <div
            className="landing-container-footer-logo"
            aria-hidden="true"
          ></div>
        </div>

        <button type="button" className="blue-link pointer" onClick={resendOtp}>
          {t("general.sendMeAgain")}
        </button>
      </form>
    </FormProvider>
  );
};
